import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "@activecollab/components";
import PropTypes from "prop-types";
import { useCreateNotebookMutation, useNotebooks } from "~/repository";

export const NotebookSelect = ({ projectId, selectedId, onChange, target }) => {
  const { t } = useTranslation();

  const { data: notebooks = [] } = useNotebooks(projectId);
  const createMutation = useCreateNotebookMutation(projectId);

  const options = useMemo(() => {
    return notebooks.map((notebook) => ({
      id: notebook.id,
      name: notebook.name,
    }));
  }, [notebooks]);

  const handleChange = useCallback(
    (selectedId) => {
      typeof onChange === "function" && onChange({ notebook_id: selectedId });
    },
    [onChange]
  );

  const handleAddNew = useCallback(
    (name) => {
      createMutation.mutate(
        {
          name,
          project_id: projectId,
        },
        {
          onSuccess: (response) => {
            if (response.single && typeof onChange === "function") {
              onChange({ notebook_id: response.single.id });
            }
          },
        }
      );
    },
    [createMutation, onChange, projectId]
  );

  return (
    <Select
      target={target}
      options={options}
      defaultValue={t("Notes")}
      selected={selectedId > 0 ? selectedId : undefined}
      onChange={handleChange}
      forceCloseMenu
      emptyAction={handleAddNew}
      emptyValue={t("Add new notebook")}
      autoHeightMax={278}
    />
  );
};

NotebookSelect.propTypes = {
  projectId: PropTypes.number.isRequired,
  selectedId: PropTypes.number,
  onChange: PropTypes.func,
  target: PropTypes.node,
};

NotebookSelect.defaultProps = {
  selectedId: 0,
};
